'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { FC } from 'react';
import ArticleTag from '~/data/strapi/types/collection-types/article-tag';

import styles from './styles.module.css';

interface Props {
  tags: ArticleTag[];
}

const TagNavigation: FC<Props> = ({ tags }) => {
  const params = useSearchParams();
  const pathname = usePathname();

  const currentTag = params.get('tag');

  const getTagHref = (tagId?: string | null): string => {
    const baseUrl = `${pathname}`;
    if (!tagId) return `${baseUrl}`;
    return `${baseUrl}?tag=${tagId}`;
  };

  return (
    <nav className={styles.tagsNav}>
      <Link href={getTagHref()} className={clsx(styles.tagLink, !currentTag && styles.activeTag)} scroll={false}>
        Все
      </Link>
      {tags.map((tag) => (
        <Link
          key={tag.id}
          href={getTagHref(tag.slug)}
          className={clsx(styles.tagLink, currentTag === tag.slug && styles.activeTag)}
          scroll={false}
        >
          {tag.title}
        </Link>
      ))}
    </nav>
  );
};

export default TagNavigation;
